module.exports = __webpack_public_path__ + "files/77c9ee304bef82d652a2f03863efb18b.png";